<template>
    <md-content class="card">
        <md-dialog-confirm :md-active.sync="confirmDeleteClientDialog.active"
                           :md-title="$t('dialog.confirm-delete.title')"
                           :md-confirm-text="$t('dialog.confirm-delete.yes')"
                           :md-cancel-text="$t('dialog.confirm-delete.no')"
                           @md-confirm="confirmDeleteClientDialog.action()" />
        <md-table v-model="invoices.content" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
                  :md-sort-fn="customSort" @md-selected="onSelectInvoice">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" class="md-accent"
                          style="white-space: nowrap;"
                          @mouseover="currentHoverIndex = index"
                          @mouseleave="currentHoverIndex = null"
                          @dblclick="onSelect(item)"
                          md-selectable="multiple" md-auto-select>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.id')">{{ getNo(index) }}</md-table-cell>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.invoicesNumber')" md-sort-by="invoiceNumber">
                    {{ item.invoiceNumber }}
                </md-table-cell>
                  <md-table-cell :md-label="$t('views.invoices.list.table.label.subject')" md-sort-by="agencyName">
                    {{ item.agencyName }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.invoicesType')" md-sort-by="invoiceType">
                  {{ item.invoiceType && $t(`views.invoices.types.${item.invoiceType.toUpperCase()}`) }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.createdAt')" md-sort-by="createdAt">
                    {{ item.createdAt | moment('L') }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.openedAt')" md-sort-by="openedAt">
                    {{ item.openedAt | moment('L') }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.invoices.list.table.label.openedBy')" md-sort-by="openedBy">
                    {{ item.openedBy }}
                </md-table-cell>
                <div class="actions-invoices-extra" v-if="currentHoverIndex == index">
                  <conditional-router-link :to="onSelectRouterButton(item)">
                    <md-button class="md-icon-button">
                      <md-tooltip md-direction="top">{{ $t('view') }}</md-tooltip>
                      <md-icon>search</md-icon>
                    </md-button>
                  </conditional-router-link>
                </div>
            </md-table-row>
            <md-table-empty-state v-if="!loading" class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />
        </md-table>
        <div class="md-layout right">
            <paginator :page.sync="currentPage" :length="invoices.totalElements || 0" :page-size.sync="pageSize"
                        @pageChange="loadInvoices(currentPage, pageSize, sort, filterValue)" class="right" />
        </div>
    </md-content>
</template>

<script>
  import {invoicesExtraordinaryEndpoint} from '@/services/adsign-backend/endpoints'
  import ConditionalRouterLink from '@/components/ConditionalRouterLink';
  import {FilterType} from '@/mixins/filterType';
  import sortSupport from '@/mixins/sortSupport';
  import Paginator from '@/components/Paginator';
  import Spiner from '@/components/Spiner'
  import { mapGetters } from "vuex";
  import store from '@/store'
  import ExcelDownloader from '@/utils/exelDownloader-utils'

  const moment = require('moment');

  export default {
    name: 'InvoicesExtraordinaryList',
    mixins: [sortSupport],
    components: {Paginator, ConditionalRouterLink, Spiner},
    props: {
      orderId: {
            type: [Number, String],
            default: undefined,
      },
      filterValueProp: {
        type: String,
        default: ''
      },
      position:{
        type: Number,
        default: undefined
      }
    },
    computed: {
      ...mapGetters("misc", ["currentSortList"]),
      ...mapGetters("misc", ["searcherFilterData"])
    },
    created(){
          if(this.orderId == undefined){
            this.currentSort = this.currentSortList.sortBy
            this.currentSortOrder = this.currentSortList.sortOrder
            this.pageSize = this.currentSortList.pageSize
            this.filterValue = this.searcherFilterData.filter
            this.searchExpand = this.searcherFilterData.searchExpand
          }
    },
    data: () => ({
      confirmDeleteClientDialog: {
        active: false,
        action: undefined
      },
      searchExpand: false,
      currentSort: 'id',
      currentSortOrder: 'asc',
      invoices: {
        pageable: {
          pageNumber: 0,
          pageSize: 0,
          filter: null
        },
        totalElements: null,
        content: [],
        ids: []
      },
      filterValue: '',
      filterDataModel: [
        {id: 'invoiceNumber', type: FilterType.String},
        {id: 'invoiceType', type: FilterType.String},
        {id: 'createdAt', type: FilterType.Date},
        {id: 'openedAt', type: FilterType.Date},
        {id: 'openedBy', type: FilterType.String},
        {id: 'agencyName', type: FilterType.String}
      ],
      currentHoverIndex: null,
      loading: false
    }),
    mounted() {
        this.$watch(() => this.filterValueProp, (result) => {
          this.filterValue = result
          this.loadInvoices(this.currentPage, this.pageSize, this.sort, result);
        })
        store.commit('order/IS_ARCHIVE', false)
        store.commit('order/IS_EXTRAORDINARY', true)
    },
    watch: {
      $route(to,from){
        this.loadInvoices(this.pageNumber, this.pageSize, this.sort, this.filterValue);
      }
    },
    methods: {
      customSort(value) {
        this.searchTemplate();
        return value;
      },
      loadInvoices(page, pageSize, sort, filter) {
        this.loading = true
        invoicesExtraordinaryEndpoint.getInvoices(page - 1, pageSize, sort, filter)
            .then(result => {
              this.invoices = result.data;
              this.$emit('isContent', result.data.content.length);
            })
            .catch(this.handleServerValidationError)
            .finally(() => this.loading = false, store.commit('misc/SORT_LIST', {sortBy: this.currentSort, sortOrder: this.currentSortOrder, pageSize: this.pageSize}), this.$emit('setDataModel', this.filterDataModel))
      },
      searchTemplate() {
        this.loadInvoices(this.pageNumber, this.pageSize, this.sort, this.filterValue);
      },
      onSelect(item){
            this.$router.push(`/invoices_extraordinary_list/view/${item.id}`)
      },
      onSelectRouterButton(item){
          return `/invoices_extraordinary_list/view/${item.id}`
      },
      onSelectInvoice(items) {
        this.ids = [];
        this.selected = items;

        if (items.length > 0) {
          items.forEach(item => {
            this.ids.push(item.id);
          });
        }

        this.$emit('addArchiveInvoicesIds', this.ids);
      },
      downloadExcel(){
        let table
        table = new ExcelDownloader(document.querySelector('table'))
        table.exportXLS(`Faktury_Bonusowe_${this.pageSize}_Strona_${this.currentPage}`)
      },
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep{
    .md-header-btn:disabled{
      background: rgb(200, 200, 200);
      box-shadow: none;
      color: rgb(120, 120, 120) !important
    }

    .md-table-head-container {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }

    .md-table-cell-container {
      padding-left: 20px !important;
      padding-right: 15px !important;
    }
  }
</style>

